import { defineCountry } from '../../../src/domain/country/factory';
import * as languages from '../../languages';

export default defineCountry({
  countryName: 'Malaysia',
  countryCode: 'MY',
  countryHeaderCode: 'my',
  mobileRegex: /^(?:0?1\d{8,9})$/,
  mobileLength: 9,
  mobileCode: '+60',
  prefixesToRemove: ['0'],
  consentForCallback: {
    shouldShow: true,
  },
  languages: {
    [languages.en.languageCode]: {
      bookingFlowConfig: {
        isDesktopBkfEnabled: false,
        isMobileBkfEnabled: false,
      },
      defaultAgreedDocs: {
        tncUrl: '/en-MY/terms-of-service',
        privacyPolicyUrl: '/en-MY/privacy-policy',
      },
      currencyConfig: {
        currencyLocale: 'en-MY',
        currencyCode: 'MYR',
        maxMinorDigits: 2,
        currencySymbol: 'RM',
      },
    },
  },
  defaultLanguage: languages.en,
  googleAutoCompletePlacesCode: 'my',
  trackOrderContactSupportNumber: '+60',
});
